import Framework from 'framework';
import { proxyToClubsStore } from './proxyToEnterpriseFramework';

const ClubsStore = {
	name: 'ClubsStore',
	getInitialData: proxyToClubsStore('getInitialData'),
	initialize: proxyToClubsStore('initialize'),
	listen: proxyToClubsStore('listen')
};

Framework.registerStore(ClubsStore.name, ClubsStore);

export default ClubsStore;
